"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Text_1 = require("../Text");
var helpers_1 = require("../helpers");
var layouts_1 = require("../layouts");
exports.FormTitleInner = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n\n    ", "\n"], ["\n    position: relative;\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        height: ", ";\n\n        &::before {\n            content: '';\n            z-index: 1;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: -", ";\n            right: -", ";\n            background-color: ", ";\n        }\n\n        ", " > * {\n            position: relative;\n            z-index: 999;\n        }\n\n        ", " {\n            width: 100%;\n            line-height: ", ";\n            padding: 0 ", " 0 0;\n            z-index: 2;\n        }\n    "], ["\n        height: ", ";\n\n        &::before {\n            content: '';\n            z-index: 1;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: -", ";\n            right: -", ";\n            background-color: ", ";\n        }\n\n        ", " > * {\n            position: relative;\n            z-index: 999;\n        }\n\n        ", " {\n            width: 100%;\n            line-height: ", ";\n            padding: 0 ", " 0 0;\n            z-index: 2;\n        }\n    "])), theme.spacing.xl, theme.spacing.s, theme.spacing.s, theme.colorBackgroundNeutralLight, Text_1.Text.selector, Text_1.Text.selector, theme.spacing.xl, theme.spacing.s);
});
var FormTitleInnerWithRightAddon = styled_components_1.default(exports.FormTitleInner)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n\n    & > * {\n        z-index: 1;\n    }\n"], ["\n    display: flex;\n\n    & > * {\n        z-index: 1;\n    }\n"])));
var StyledTr = styled_components_1.default.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: table-row;\n"], ["\n    display: table-row;\n"])));
var FormTitleTextWrapper = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.m, weight: Text_1.TEXT_WEIGHT.semiBold, truncate: true },
        react_1.default.createElement("span", null, children)));
};
var RightAddonWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var ContentFormTitleInner = function (_a) {
    var children = _a.children, rightAddon = _a.rightAddon;
    if (rightAddon) {
        return (react_1.default.createElement(FormTitleInnerWithRightAddon, null,
            react_1.default.createElement(FormTitleTextWrapper, null, children),
            react_1.default.createElement(layouts_1.Spacer, null),
            react_1.default.createElement(RightAddonWrapper, null, rightAddon)));
    }
    return (react_1.default.createElement(exports.FormTitleInner, null,
        react_1.default.createElement(FormTitleTextWrapper, null, children)));
};
exports.FormTitle = helpers_1.createUIElement('FormTitle', function (_a, ref) {
    var className = _a.className, children = _a.children, rightAddon = _a.rightAddon, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "rightAddon", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StyledTr, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-FormTitle " + className, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement("td", { colSpan: 2 },
            react_1.default.createElement(ContentFormTitleInner, { rightAddon: rightAddon }, children))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=FormTitle.js.map